<template>
  <div class="drawer fixed bottom-0 right-0 z-30 flex w-full justify-end">
    <div class="an-min-w-full relative z-30 h-full overflow-hidden bg-white">
      <div
        class="z-30 flex h-12 w-full items-center justify-between border-b border-gray-200 px-4"
      >
        <slot name="header" />
      </div>

      <div class="box-border h-full max-w-full py-2">
        <slot name="content" />
      </div>
    </div>

    <div
      v-if="withOverlay"
      class="fixed left-0 top-0 z-20 h-full w-full bg-black opacity-20"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    withOverlay?: boolean;
  }>(),
  {
    withOverlay: false,
  },
);
</script>

<style scoped>
* {
  will-change: width;
}

.drawer {
  height: 50%;
  width: 100vw;
  bottom: 0;
}

@screen sm {
  .drawer {
    height: 100%;
    width: 43vw;
  }
}

@screen lg {
  .drawer {
    width: 33vw;
  }
}
</style>
